"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.knowledgeProject.list': '项目',
    'route.knowledgeProject.create': '添加项目',
    'route.knowledgeProject.edit': '编辑项目',
};
